<template>
  <v-data-table
    :headers="headers"
    :items="desserts"
    sort-by="calories"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-toolbar-title>Достижения</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <v-dialog
          v-model="dialog"
          max-width="500px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              class="mb-2"
              v-bind="attrs"
              v-on="on"
            >
              Добавить новое
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-select
                      :items="achievementsItems"
                      label="Достижение"
                      v-model="editedItem.id"
                    >
                    </v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model="editedItem.level"
                      label="Уровень"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="close"
              >
                Отменить
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="save"
              >
                Сохранить
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5">Вы уверены что хотите удалить достижение пользователя?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete">Отменить</v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">Удалить</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="initialize"
      >
        Reset
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>

import AchievementListGQL from '@/graphql/private/Achievement/List.gql'
import UserAchievementAddGQL from '@/graphql/private/UserAchievement/Add.gql'
import UserAchievementDelGQL from '@/graphql/private/UserAchievement/Remove.gql'

import notify from '@/mixins/notify'

export default {
  mixins: [notify],
  props: {
    desserts: {
      type: Array,
      default: null,
    },
    userID: {
      type: String
    },
  },
  data: () => ({
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: 'Достижение',
        align: 'start',
        sortable: false,
        value: 'achievement.name',
      },
      {
        text: 'Уровень',
        value: 'level',
        sortable: false
      },
      {
        text: 'Действия',
        value: 'actions',
        sortable: false
      },
    ],
    editedIndex: -1,
    editedItem: {
      level: '',
    },
    defaultItem: {
      level: '',
    },
  }),
  apollo: {
    achievementList: {
      query: AchievementListGQL,
      variables() {
        return {
          filter: {
            locale: 'ru',
          },
        }
      },
    },
  },
  computed: {
    achievementsItems() {
      if (!this.achievementList) {
        return []
      }
      return this.achievementList.map(item => {
        return {
          text: item.name,
          value: item.id,
        }
      })
    },
    formTitle() {
      return this.editedIndex === -1 ? 'Новое достижение' : 'Редактирование достижения'
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
    dialogDelete(val) {
      val || this.closeDelete()
    },
  },

  created() {
    this.initialize()
  },

  methods: {
    initialize() {
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      if (this.editedItem.achievement) {
        this.editedItem.id = this.editedItem.achievement.id
      }
      this.dialog = true
    },

    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
    },

    async deleteItemConfirm() {
      try {
        await this.$apollo.mutate({
          mutation: UserAchievementDelGQL,
          variables: {
            user_id: this.userID,
            achievement_id: this.editedItem.achievement.id,
          },
          refetchQueries: ['userAchievementList'],
          awaitRefetchQueries: true
        })
        this.notify({
          text: 'Достижение удалено!',
        })
        // refetch
      } catch (err) {
        this.notify({
          text: err.message,
          type: 'error',
        })
        throw new Error(err)
      }

      this.closeDelete()
    },

    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    closeDelete() {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    async save() {
      try {
        await this.$apollo.mutate({
          mutation: UserAchievementAddGQL,
          variables: {
            achievement: {
              achievementID: this.editedItem.id,
              userID: this.userID,
              level: this.editedItem.level,
            },
          },
          refetchQueries: ['userAchievementList'],
          awaitRefetchQueries: true
        })
        this.notify({
          text: 'Достижение обновлено!',
        })
        // refetch
      } catch (err) {
        this.notify({
          text: err.message,
          type: 'error',
        })
        throw new Error(err)
      }
      this.close()
    },
  },
}
</script>
